// extracted by mini-css-extract-plugin
export default {"titleImage":"ResetPasswordPage_titleImage__67Eas","message":"ResetPasswordPage_message__4a725","contactUs":"ResetPasswordPage_contactUs__Fqntr"};